import { memo } from 'react';

import PowerAutomateIcon from '@/assets/power-automate-logo.svg?react';
import { Logo, LogoProps } from '@/components/core';

export type PowerAutomateLogoProps = LogoProps;

const IPowerAutomateLogo = ({ className, ...rest }: PowerAutomateLogoProps) => {
  return (
    <Logo className={className} {...rest}>
      <PowerAutomateIcon />
    </Logo>
  );
};

export const PowerAutomateLogo = memo(IPowerAutomateLogo) as typeof IPowerAutomateLogo;
